import COS from 'cos-js-sdk-v5'
import SparkMD5 from 'spark-md5'
import axios from 'axios'
// import { getCOSAuth } from '@/api/collect/cos'
var key = ''
// 配置
const cosConfig = {
  Bucket: 'training-1252311801',
  Region: 'ap-shanghai',
  Domain: 'https://training-1252311801.file.myqcloud.com'
}

function getCOSAuth (parameter) {
	var token  = localStorage.getItem('token');
  return axios({
		url:"https://www.qsfzpx.com/api/cos/getCOSAuth",
		method:'get',
		headers:{'content-type':'application/json','source':0,'access-token':token},
  })
}
// 初始化实例
var cos = new COS({
  getAuthorization: async function(options, callback) {
    const res = await getCOSAuth()
    const authdata = res.data.data
    const auth = {
      TmpSecretId: authdata.tmpSecretId,
      TmpSecretKey: authdata.tmpSecretKey,
      XCosSecurityToken: authdata.sessionToken,
      ExpiredTime: authdata.expiredTime // 在ExpiredTime时间前，不会再次调用getAuthorization
    }
    callback(auth)
  },
  FileParallelLimit: 3, // 文件并发数
  ChunkParallelLimit: 8, // 同一个上传文件的分块并发数
  ChunkSize: 1024 * 1024 * 8 // 分块上传时，每块的字节数大小
})
// 获取cos存储的图片地址，替换为域名地址
function getObjectUrl() {
  const url = cos.getObjectUrl({
    Bucket: cosConfig.Bucket,
    Region: cosConfig.Region,
    Key: key,
    Sign: false
  }, function(err, data) {
    // console.log(err || data)
  })
  // 腾讯云的地址替换为域名地址
  const p = `${cosConfig.Bucket}.cos.${cosConfig.Region}.myqcloud.com`
  return url.replace("http","http")
}

// 获得文件md5
function getFileMD5(file, callback) {
  // 声明必要的变量
  const fileReader = new FileReader()
  // 文件每块分割2M，计算分割详情
  const chunkSize = 2 * 1024 * 1024;
  const chunks = Math.ceil(file.size / chunkSize)
  let currentChunk = 0

  // 创建md5对象（基于SparkMD5）
  const spark = new SparkMD5()

  // 每块文件读取完毕之后的处理
  fileReader.onload = function(e) {
    // 每块交由sparkMD5进行计算
    spark.appendBinary(e.target.result)
    currentChunk++

    // 如果文件处理完成计算MD5，如果还有分片继续处理
    if (currentChunk < chunks) {
      loadNext()
    } else {
      callback(spark.end())
    }
  }

  // 处理单片文件的上传
  function loadNext() {
    const start = currentChunk * chunkSize
    const end = start + chunkSize >= file.size ? file.size : start + chunkSize

    fileReader.readAsBinaryString(file.slice(start, end))
  }
  loadNext()
}

/**
 * 生成文件格式:
 * @param file
 * @param callback
 * @param progressBc
 */
// 大文件分片上传-通过sliceUploadFile上传
export function uploadFile(params,callback, progressBc) {
  // 得到md5码
  let file = params.file.file,
      path = params.path;
  getFileMD5(file, md5 => {
    // 存储文件的md5码
    file.md5 = md5
    const subfix = file.name.substr(file.name.lastIndexOf('.'))
    key = path+'/'+ new Date().getFullYear()+'/'+(new Date().getMonth()+1)+'/'+new Date().getDate()+'/'+ file.md5 + subfix;
    cos.sliceUploadFile({
      Bucket: cosConfig.Bucket,
      Region: cosConfig.Region,
      Key: key,
      Body: file,
      onProgress: function(progressData) {

        progressBc(progressData.percent)
      }
    }, function(err, data) {
      if (err) {
        callback(err)
      } else {
        data.fid = getObjectUrl()
        callback(null, data)
      }
    })
  })
}

// 小文件直接上传-通过putObject上传
export function uploadFile2(file, callback, progressBc) {
  // 得到md5码
  getFileMD5(file, md5 => {
    // 存储文件的md5码
    file.md5 = md5
    const subfix = file.name.substr(file.name.lastIndexOf('.'))
    key = file.md5 + subfix
    cos.headObject({
      Bucket: cosConfig.Bucket,
      Region: cosConfig.Region,
      Key: key
    }, function(err, data) {
      if (err != null) {
        cos.putObject({
          Bucket: cosConfig.Bucket,
          Region: cosConfig.Region,
          Key: key,
          Body: file,
          onProgress: function(progressData) {
            // console.log(JSON.stringify(info))
            progressBc(progressData.percent)
          }
        }, (err, data) => {
          if (err && err.error) {
            // wx.showModal({ title: '返回错误', content: '请求失败：' + err.error.Message + '；状态码：' + err.statusCode, showCancel: false });
          } else if (err) {
            // wx.showModal({ title: '请求出错', content: '请求出错：' + err + '；状态码：' + err.statusCode, showCancel: false });
          } else {
            callback(key)
            //  wx.showToast({ title: '上传成功', icon: 'success', duration: 3000 });
          }
        })
      } else if (data != null) {
        callback(key)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/uploadfile.js